import BaseSetup from '@/components/BaseSetup';
import { ORDER_PROPOSAL_STATUS } from '@/typings/enums/ORDER_PROPOSAL_STATUS';
import { Reactive } from '@/utils/decorators';
import { Bus, sleep, useTour } from '@orion.ui/orion';
import { ref } from 'vue';

export type TourOrderDetailsClientEmits = {};
export type TourOrderDetailsClientProps = {};

export default class TourOrderDetailsClientSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _tourOrderDetailsClient = ref<OrionTour>();

	@Reactive private readonly state = { canCopy: false };

	get canCopy () { return this.state.canCopy }

	readonly sampleProposal: IOrderClientProposalWithUserModel = {
		id: 0,
		status: ORDER_PROPOSAL_STATUS.Accepted,
		createdDate: '2023-12-08',
		tempWorkerUser: {
			id: 0,
			firstName: 'John',
			lastName: 'McKenzy',
			personalInformationCountry: 'FR',
			personalInformationPostCode: '68000',
			personalInformationCity: 'Colmar',
			userProfileCommentsCount: 0,
			professionalSkills: [
				{
					id: 0,
					code: '30063',
					label: this.$t('common.label.warehouseWorker'),
				},
			],
			profileIsPublic: true,
		},
	};

	constructor (
		private props: TourOrderDetailsClientProps,
		private emits: TourOrderDetailsClientEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();
		useTour('tourOrderDetailsClient', this._tourOrderDetailsClient.value);
		this.registerBusEvent('canCopy', (payload) => {
			this.state.canCopy = payload;
		});
	}

	openDiscussion () {
		Bus.emit('OrderDetailsSetup:openDiscussion');
		useTour('tourOrderDetailsClient').stop();
	}

	scrollToId (id: string) {
		const elem = document.getElementById(id);
		elem?.scrollIntoView();
		return document.getElementById(id);
	}

	getTarget () {
		return document.getElementById('order-details-client-candidates');
	}

	getProposedCandidates () {
		return document.getElementById('order-details-client-candidates');
	}

	goToValidatedCandidates () {
		return {
			callback: () => {
				return new Promise(async (resolve) => {

					await this.router.push({ name: 'OrderDetailsStatus' });
					await sleep(600);
					resolve(true);

				});
			},
		};
	}

	goToOrderDetails () {
		return {
			callback: () => {
				return new Promise(async (resolve) => {

					await this.router.push({ name: 'OrderDetailsRecap' });
					await sleep(600);
					resolve(true);

				});
			},
		};
	}

}
